<template>
  <el-form-item
    :prop="form.model"
    :class="[form.options.required ? 'label-blue' : '']"
    :rules="form.rules"
    :required="form.options.required"
    :label="form.name"
    style="padding-left: 10px; line-height: 36px"
  >
    <el-tooltip :content="value[form.model] == '0' ? '关' : '开'" placement="right">
      <el-switch
        style="width: 226px"
        v-model="value[form.model]"
        @change="onInput"
        active-value="1"
        inactive-value="0"
        :disabled="inputDisable"
      >
      </el-switch>
    </el-tooltip>
  </el-form-item>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  name: "DynamicSwitch",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      key: "",
      formData: {},
      mainValue: "",
      onValue: "1",
      offValue: "0",
    };
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          options: {
            defaultValue: "0",
            required: false,
            disabled: false,
            customClass: "",
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true,
          },
          name: "",
          novalid: {},
          key: "",
          model: "value",
          rules: [],
        };
      },
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        this.mainValue = val;
      },
    },
  },
  methods: {
    onInput() {
      let that = this;
      that.$emit("input", that.value, that.form.model);
      if (typeof that.form.options.changeFunc === "function") {
        // 判断是否存在数据改变事件
        that.form.options.changeFunc(that.value[that.form.model], that, that.forms);
      }
    },
    onFocus() {
      let that = this;
      if (typeof that.form.options.onFocus === "function") {
        // 判断是否存在数据改变事件
        that.form.options.onFocus();
      }
    },
  },
  created() {
    let that = this;
    that.key = that.form.key;
    if (that.form.hasOwnProperty("options")) {
      that.value[that.form.model] =
        that.value[that.form.model] || this.form["options"]["defaultValue"] || "0";
    }
  },
  mounted() {
    let that = this;
    that.$emit("init", that.key, that);
  },
  computed: {
    inputDisable() {
      return this.disabled || this.form.options.disabled;
    },
  },
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicSwitch.vue"
}
</vue-filename-injector>
